/* Progressive enhancement: content is visible and details work before JS. */
(() => {
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const seen = new WeakSet();
 const animations = new Set();
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
   if (!entry.isIntersecting) return;
   observer.unobserve(entry.target);
   if (seen.has(entry.target) || reduced.matches) return;
   seen.add(entry.target);
   const animation = entry.target.animate([{ opacity: .2, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
   animations.add(animation);
   animation.finished.finally(() => animations.delete(animation)).catch(() => {});
  });
 }, { threshold: .12 });
 const observe = root => root.querySelectorAll('[data-sd-reveal]').forEach(element => observer.observe(element));
 observe(document);
 document.addEventListener('shopify:section:load', event => observe(event.target));
 document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-sd-reveal]').forEach(element => observer.unobserve(element)));
 reduced.addEventListener('change', () => { if (reduced.matches) animations.forEach(animation => animation.cancel()); });
})();

if (!customElements.get('solid-design-technology')) {
 customElements.define('solid-design-technology', class extends HTMLElement {
  connectedCallback() {
   this.abort = new AbortController();
   const { signal } = this.abort;
   const reduced = matchMedia('(prefers-reduced-motion: reduce)');
   const panels = [...this.querySelectorAll('[data-sd-feature]')];
   panels.forEach((panel, index) => panel.addEventListener('toggle', () => {
    if (!panel.open) return;
    panels.forEach(other => { if (other !== panel) other.open = false; });
    this.dataset.state = String(index);
    this.querySelector('[data-sd-detail-count]').textContent = String(index + 1).padStart(2, '0');
    if (!reduced.matches) panel.querySelector('.sd-detail-body').animate([{ opacity: 0, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 260, easing: 'ease-out' });
   }, { signal }));
  }
  disconnectedCallback() { this.abort?.abort(); }
 });
}
